module.exports = __webpack_public_path__ + "img/record_icon.d0289dc0.png";